"use strict";

var _Icon, _AsyncBoundary;
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useAuth } from '@autoguru/auth';
import { Drawer } from '@autoguru/components';
import { windowAsideToggleFnName } from '@autoguru/components/components/AppAsideHandle/AppSideHandle';
import { WindowCloseIcon } from '@autoguru/icons';
import { Box, Button, Icon, ScrollPane, StickyBox, useBoxStyles, useMedia } from '@autoguru/overdrive';
import { AsyncBoundary } from '@autoguru/suspense';
import { startTransition, useCallback, useRef, useState } from 'react';
import { ExpandSideNavLinks } from '../ExpandSideNavLinks';
import { ExpandSideNavProvider, useExpandSideNav } from '../ExpandSideNavProvider';
import * as styles from './ExpandSideNav.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const pageAsidePortalId = '__ag-aside__';
export const ExpandSideNavComponent = () => {
  const {
    isAuthenticated
  } = useAuth();
  const [notMobile] = useMedia(['tablet'], false);
  const [isOpen, setIsOpen] = useState(false);
  const {
    setIsExpanded
  } = useExpandSideNav({});
  window[windowAsideToggleFnName] = () => setIsOpen(true);
  const onRequestClose = useCallback(() => {
    setIsOpen(false);
  }, []);
  const handleMouseEnter = useCallback(() => {
    startTransition(() => {
      setIsExpanded === null || setIsExpanded === void 0 || setIsExpanded(true);
    });
  }, [setIsExpanded]);
  const handleMouseLeave = useCallback(() => {
    startTransition(() => {
      setIsExpanded === null || setIsExpanded === void 0 || setIsExpanded(false);
    });
  }, [setIsExpanded]);
  const containerRef = useRef(null);
  return notMobile ? /*#__PURE__*/_jsx(StickyBox, {
    noPopShadow: true,
    top: "none",
    zIndex: 3,
    height: "full",
    className: styles.desktopRoot,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    children: /*#__PURE__*/_jsx(ScrollPane, {
      className: styles.scrollPane,
      ref: containerRef,
      position: "relative",
      borderColour: "light",
      borderWidthRight: "1",
      backgroundColour: "white",
      children: /*#__PURE__*/_jsx(ExpandSideNavLinks, {
        layout: "desktop",
        minHeight: "100dvh",
        className: styles.desktopLinks,
        isAuthed: isAuthenticated
      })
    })
  }) : /*#__PURE__*/_jsx(Drawer, {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    direction: "RIGHT_TO_LEFT",
    children: /*#__PURE__*/_jsxs(ScrollPane, {
      className: styles.scrollPane,
      ref: containerRef,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      position: "relative",
      borderColour: "light",
      borderWidthRight: "1",
      backgroundColour: "white",
      children: [/*#__PURE__*/_jsx(Box, {
        paddingX: "4",
        paddingY: "2",
        children: /*#__PURE__*/_jsx(Button, {
          minimal: true,
          rounded: true,
          variant: "secondary",
          "aria-role": "button",
          "aria-label": "close",
          onClick: onRequestClose,
          children: _Icon || (_Icon = /*#__PURE__*/_jsx(Icon, {
            size: "medium",
            icon: WindowCloseIcon
          }))
        })
      }), /*#__PURE__*/_jsx(ExpandSideNavLinks, {
        className: useBoxStyles({
          flexGrow: 1
        }),
        layout: "mobile",
        isAuthed: isAuthenticated
      })]
    })
  });
};
export const ExpandSideNav = ({
  asideItems,
  includeAuth,
  logoutRedirect,
  logoutUrl,
  stringTokens
}) => /*#__PURE__*/_jsx(ExpandSideNavProvider, {
  includeAuth: includeAuth,
  logoutRedirect: logoutRedirect,
  logoutUrl: logoutUrl,
  labelClassName: styles.linkLabels,
  asideItems: asideItems,
  stringTokens: stringTokens,
  children: _AsyncBoundary || (_AsyncBoundary = /*#__PURE__*/_jsx(AsyncBoundary, {
    fallback: null,
    children: /*#__PURE__*/_jsx(ExpandSideNavComponent, {})
  }))
});